import { Text } from "react-native";

export function parseMarkdown(markdownText) {
  const elements = [];
  let lastIndex = 0;

  if (!markdownText) return <Text>{markdownText}</Text>;

  const regex =
    /(\*\*([^*]+)\*\*|\*([^*]+)\*|`([^`]+)`|\^(\d+)\^)/g;

  let match;
  let key = 0;

  while ((match = regex.exec(markdownText)) !== null) {
    if (match.index > lastIndex) {
      elements.push(
        <Text key={key++}>{markdownText.slice(lastIndex, match.index)}</Text>
      );
    }

    if (match[2]) {
      // **fett**
      elements.push(
        <Text key={key++} style={{ fontWeight: "bold" }}>
          {match[2]}
        </Text>
      );
    } else if (match[3]) {
      // *kursiv*
      elements.push(
        <Text key={key++} style={{ fontStyle: "italic" }}>
          {match[3]}
        </Text>
      );
    } else if (match[4]) {
      // `Code`
      elements.push(
        <Text key={key++} style={{ fontFamily: "monospace", backgroundColor: "#eee" }}>
          {match[4]}
        </Text>
      );
    } else if (match[5]) {
      // ^1^ → Hochgestellt
      elements.push(
        <Text key={key++} style={{ fontSize: 10, verticalAlign: "super" }}>
          {match[5]}
        </Text>
      );
    }

    lastIndex = regex.lastIndex;
  }

  if (lastIndex < markdownText.length) {
    elements.push(<Text key={key++}>{markdownText.slice(lastIndex)}</Text>);
  }

  return elements;
}